import { render, staticRenderFns } from "./AccrualsEstimateActivityTab.vue?vue&type=template&id=b5ca22d2&scoped=true"
import script from "./AccrualsEstimateActivityTab.vue?vue&type=script&lang=js"
export * from "./AccrualsEstimateActivityTab.vue?vue&type=script&lang=js"
import style0 from "./AccrualsEstimateActivityTab.vue?vue&type=style&index=0&id=b5ca22d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ca22d2",
  null
  
)

export default component.exports